/*
 * Copyright (c) 2019 brightlamp
 */

import { initializeApp } from "firebase/app"
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithPopup, signInWithRedirect, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence, browserSessionPersistence, updateProfile, updatePassword, verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";

const config =
{
  apiKey: 'AIzaSyCEme8SaY4vs9MhpHOsBNGznLLLY9nRu98',
  authDomain: 'reflex-c1940.firebaseapp.com',
  projectId: 'reflex-c1940',
  messagingSenderId: "775444496378",
  appId: '1:775444496378:web:6af0ba1918195c9bff6e43',
  measurementId: "G-QMFJ05DDZ5"
};

const firebaseApp = initializeApp(config);
const firebaseAnalytics = getAnalytics(firebaseApp);
const firebaseAuth = getAuth(firebaseApp);

export { firebaseApp, firebaseAuth, onAuthStateChanged, firebaseAnalytics, logEvent, setUserId, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithPopup, signInWithRedirect, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence, browserSessionPersistence, updateProfile, updatePassword, verifyPasswordResetCode, confirmPasswordReset }